import { Flex, Group, Text } from '@mantine/core';

import { SIMULATION_STATUSES } from '../../config';
import { useSimulationStatus } from '../../hooks';
import { PopoverActions } from '../PopoverContent/PopoverActions';
import { PopoverContent } from '../PopoverContent/PopoverContent';
import { FormProvider } from './FormContextProvider';

export const SimulationContent = () => {
  const simulationStatus = useSimulationStatus();

  return (
    <Flex px={20} py={16} bg="white" direction="column" h="100%" style={{ borderRadius: '0 0 12px 12px' }}>
      {simulationStatus.data ? (
        <FormProvider status={simulationStatus.data.status as SIMULATION_STATUSES}>
          <PopoverContent />
          <PopoverActions />
        </FormProvider>
      ) : (
        <Group>
          <Text fw={600}>Application Status</Text>
          <Text c="dimmed">No Hosted Application</Text>
        </Group>
      )}
    </Flex>
  );
};
